<template>
	<div class="online-products">
		<el-row type="flex" align="middle">
			<el-button type="primary">在售（{{ total }}）</el-button>
			<el-form label-width="120px">
				<el-form-item label="选择店铺" style="margin: 0;">
					<el-select
						v-model="shopItem"
						value-key="shopId"
						@change="selectChange"
					>
						<el-option
							v-for="item in listShop"
							:key="item.shopId"
							:label="item.shopName"
							:value="item"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</el-row>

		<el-form inline>
			<el-form-item label="内容搜索" style="margin: 0;">
				<el-input
					placeholder="标题名称、产品ID、SKU"
					style="width: 270px;"
					v-model="idTitleSku"
				></el-input>
				<el-button
					type="primary"
					style="margin-left: 10px;"
					@click="searchForm"
					>搜索</el-button
				>
				<el-button
					type="primary"
					style="margin-left: 10px;"
					@click="resectForm"
					>重置</el-button
				>
			</el-form-item>
		</el-form>
		<el-row style="margin: 10px 0;"
			>符合查询条件的产品有{{ total }}件</el-row
		>
		<el-row style="margin: 10px 0;" type="flex" align="middle">
			<div style="margin-right: 10px;">
				已选择{{ listChecked.length }}件
			</div>
			<el-button type="text" @click="openComponentsDialog('ModifyPrice')"
				>修改价格</el-button
			>
			<el-button type="text" @click="openComponentsDialog('ModifyStock')"
				>修改库存</el-button
			>
			<el-button type="text" @click="openComponentsDialog('ModifyInfo')"
				>修改基本信息</el-button
			>
			<el-button type="text" @click="openComponentsDialog('ModifyImg')"
				>修改图片</el-button
			>
		</el-row>
		<el-table
			ref="multipleTable"
			:data="listTable"
			border
			v-loading="loadingTable"
			lazy
			:load="tableLoad"
			row-key="id"
			:tree-props="{ children: 'children', hasChildren: 'variantCount' }"
			@select-all="handleCheckedAllChange"
			:header-cell-style="{ textAlign: 'center' }"
		>
			<el-table-column type="selection" align="center">
				<template slot-scope="scope" v-if="scope.row.isShow">
					<el-checkbox
						v-model="scope.row.isChecked"
						@change="handleCheckedOneChange($event, scope.row)"
					></el-checkbox>
				</template>
			</el-table-column>
			<el-table-column label="变体" align="center" width="140">
				<template slot-scope="scope" v-if="scope.row.isShow">
					<span>{{ `变体(${scope.row.variantCount})` }}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="cusSku"
				label="SKU"
				align="center"
				width="200"
			></el-table-column>
			<el-table-column
				prop="productImgUrl"
				label="主图"
				align="center"
				width="80"
			>
				<template slot-scope="scope">
					<el-popover trigger="hover" placement="right">
						<el-image
							style="width: 500px;height: 500px;"
							:src="scope.row.cusImgUrl"
						></el-image>
						<div class="scope_img" slot="reference">
							<el-image
								style="width: 50px;height: 50px;"
								:src="scope.row.cusImgUrl"
							></el-image>
						</div>
					</el-popover>
				</template>
			</el-table-column>
			<el-table-column
				prop="cusTitle"
				label="标题"
				align="left"
			></el-table-column>
			<el-table-column
				prop="eanUpc"
				label="EAN"
				align="center"
				width="200"
			></el-table-column>
			<el-table-column
				prop="cusPrice"
				label="价格"
				align="center"
				width="200"
			></el-table-column>
			<el-table-column
				prop="cusPrice"
				label="促销价"
				align="center"
				width="300"
			>
				<template slot-scope="scope">
					<div>{{ scope.row.cusSalePrice }}</div>
					<div>
						{{ `开始日期：${scope.row.saleBeginTime || ''}` }}
					</div>
					<div>{{ `结束日期：${scope.row.saleEndTime || ''}` }}</div>
				</template>
			</el-table-column>
			<!--      <el-table-column label="操作" align="center" width="160">-->
			<!--        <template slot-scope="scope" v-if="scope.row.isShow">-->
			<!--          <el-dropdown trigger="click" placement="bottom">-->
			<!--            <span class="el-dropdown-link">-->
			<!--              操作-->
			<!--              <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
			<!--            </span>-->
			<!--            <el-dropdown-menu slot="dropdown">-->
			<!--              <el-dropdown-item>修改价格</el-dropdown-item>-->
			<!--              <el-dropdown-item>修改库存</el-dropdown-item>-->
			<!--              <el-dropdown-item>修改基本信息</el-dropdown-item>-->
			<!--              <el-dropdown-item>修改图片</el-dropdown-item>-->
			<!--            </el-dropdown-menu>-->
			<!--          </el-dropdown>-->
			<!--        </template>-->
			<!--      </el-table-column>-->
		</el-table>
		<el-row
			class="pagination-box"
			type="flex"
			justify="center"
			align="middle"
		>
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</el-row>

		<modify-info ref="ModifyInfo" @close="closeComponentsDialog" />
		<modify-price ref="ModifyPrice" @close="closeComponentsDialog" />
		<modify-stock ref="ModifyStock" @close="closeComponentsDialog" />
		<modify-img ref="ModifyImg" @close="closeComponentsDialog" />
	</div>
</template>

<script>
import ModifyInfo from './onlineProductsComponents/modifyInfo'
import ModifyPrice from './onlineProductsComponents/modifyPrice'
import ModifyStock from './onlineProductsComponents/modifyStock'
import ModifyImg from './onlineProductsComponents/modifyImg'
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
	name: 'OnlineProduct',
	components: {
		ModifyInfo,
		ModifyPrice,
		ModifyStock,
		ModifyImg,
	},
	data() {
		return {
			UserInfo: null,
			page: 1,
			size: 10,
			total: 0,
			listShop: [],
			shopItem: null,
			idTitleSku: '',
			listTable: [],
			loadingTable: false,
			isCheckedAll: true,
			isIndeterminate: true,
			listChecked: [],
			allTotal: -1,
		}
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.getListShop()
	},
	methods: {
		handleSizeChange(val) {
			this.size = val
			this.getListTable()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getListTable()
		},
		selectChange() {
			this.searchForm()
		},
		searchForm() {
			this.page = 1
			this.listChecked = []
			this.getListTable()
		},
		resectForm() {
			this.page = 1
			this.idTitleSku = ''
			this.getListTable()
		},
		openComponentsDialog(componentsName) {
			if (!this.listChecked.length) {
				this.$message.warning('请至少选择一条')
				return
			}
			this.$refs[componentsName].openDialog(
				this.listChecked,
				this.shopItem
			)
		},
		closeComponentsDialog() {
			this.listTable = []
			this.listChecked = []
			this.getListTable()
		},
		getListShop() {
			const API = Baseurl + 'sellerController/selectMyFineShopByRid'
			const paramsData = {
				rid: this.UserInfo.rid,
				system: this.UserInfo.system,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					if (!data.length) return
					this.listShop = data.reduce(
						(total, item) => [
							...total,
							...item.countryMarks.map((key) => {
								key.sellerId = item.sellerId
								key.mwsAuthToken = item.mwsAuthToken
								return key
							}),
						],
						[]
					)
					this.shopItem = this.listShop[0]
					this.getListTable()
				}
			})
		},
		getListTable() {
			const API = Baseurl + 'productController/productOnlineSerch'
			const paramsData = {
				page: this.page,
				size: this.size,
				staffId: this.UserInfo.rid,
				areaName: this.shopItem.countryMark,
				idTitleSku: this.idTitleSku,
			}
			this.loadingTable = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingTable = false
				const { code, data } = res.data
				if (code === 200) {
					data.list.forEach((item) => {
						item.cusSku = item.sku
						item.cusImgUrl = item.productImgUrl
						item.cusPrice = `${item.productPrice} (${item.priceCurrency})`
						item.cusSalePrice = `${item.sale || 0} (${
							item.priceCurrency
						})`
						item.cusTitle = `${item.title} ${item.sku}`
						item.cusProductPrice = item.productPrice
						item.isShow = true
						item.isChecked = false
						item.children = []
						item.saleTime = [
							item.saleBeginTime || '',
							item.saleEndTime || '',
						]
						item.cusStock = item.stock
						item.cusPreprocessingTime = item.preprocessingTime
						item.cusBluePoint = JSON.parse(item.bluePoint)
						item.editorLength = 0
						item.cusImages = item.productImgUrls
					})
					this.listTable = data.list
					this.total = data.total

					if (this.allTotal === -1) {
						this.allTotal = data.total
					}
				}
			})
		},
		async tableLoad(tree, treeNode, resolve) {
			const variantData = await this.getTableItemVariant(tree)
			tree.children = variantData
			resolve(variantData)
		},
		getTableItemVariant(tree) {
			const API = Baseurl + 'productController/selectVariantByProductId'
			const paramsData = { id: tree.id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						data.forEach((item) => {
							item.cusSku = item.childSku
							item.cusImgUrl = item.variantEanImageUrl
							const countryVal =
								item.productPriceObject[
									this.shopItem.countryMark
								]
							item.cusPrice = `${countryVal.value} (${countryVal.currency})`
							item.cusSalePrice = `${item.sale || 0} (${
								countryVal.currency
							})`
							item.cusProductPrice = `${countryVal.value}`
							item.cusTitle = `${tree.title ||
								''} ${item.childSku || ''}`
							item.isShow = false
							item.saleTime = [
								item.saleBeginTime || '',
								item.saleEndTime || '',
							]
							;(item.cusStock = item.stock),
								(item.cusImages = item.imagesList)
						})
						resolve(data)
					} else {
						reject('400')
					}
				})
			})
		},
		handleCheckedAllChange(rows) {
			this.listChecked = rows
			this.listTable.forEach((row) => (row.isChecked = !!rows.length))
		},
		handleCheckedOneChange(event, row) {
			if (event) {
				this.listChecked.push(row)
			} else {
				const itemIndex = this.listChecked.findIndex(
					(item) => item.id === row.id
				)
				if (itemIndex < 0) return
				this.listChecked.splice(itemIndex, 1)
			}
			row.isChecked = event
			this.$refs.multipleTable.toggleRowSelection(row, event)
		},
	},
}
</script>

<style lang="scss" scoped>
.online-products {
	width: 98%;
	padding-bottom: 52px;

	.pagination-box {
		width: calc(97% - 200px);
		background: #fff;
		position: fixed;
		bottom: 0;
		left: 200px;
		padding: 10px;
		z-index: 999;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #409eff;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}
}
</style>
